export default [
  {
    path: '/:lang/',
    name: 'Home',
    component: () => import('@/pages/index.vue'),
    meta: {
      name: 'home.header.Home',
      pageCode: 'ERA.UC.HOME',
      middleware: ['report'],
      headerIsWhite: true,
    },
  },
  {
    path: '/:lang/appdownload',
    name: 'AppDownload',
    component: () => import('@/pages/appdownload.vue'),
    meta: {
      name: 'AppDownload',
      pageCode: 'ERA.UC.APP.DOWNLOAD',
      noHeader: true,
    },
  },
  {
    path: '/:lang/store/home/:id',
    name: 'shopHome',
    component: () => import('@/pages/home/[id].vue'),
    meta: {
      name: 'shopHome',
      pageCode: 'ERA.UC.SHOP.HOME',
    },
  },
  {
    path: '/:lang/store/home/casestudy/:shopId/:caseId',
    name: 'shopHomeCase',
    component: () => import('@/pages/home/case/index.vue'),
    meta: {
      name: 'shopHomeCase',
      pageCode: 'ERA.UC.SHOP.HOME.CASE',
    },
  },
  {
    path: '/:lang/aboutus',
    name: 'AboutUs',
    meta: {
      name: 'home.header.Company.AboutUs',
      pageCode: 'ERA.UC.ABOUTUS',
    },
    component: () => import('~/pages/aboutus.vue'),
  },
  {
    path: '/:lang/contactus',
    name: 'contactus',
    meta: {
      name: 'home.header.Company.ContactUs',
      pageCode: 'ERA.UC.ContactUs',
    },
    component: () => import('~/pages/contactus.vue'),
  },
  {
    path: '/:lang/JoinUs',
    name: 'JoinUs',
    meta: {
      name: 'home.header.Company.JoinUs',
      pageCode: 'ERA.UC.JoinUs',
    },
    component: () => import('~/pages/JoinUs.vue'),
  },
  {
    path: '/:lang/jcpay',
    name: 'JCPay',
    meta: {
      name: 'home.header.JCPay.name',
      pageCode: 'ERA.UC.JCPay',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/search',
    name: 'GlobalSearch',
    meta: {
      name: 'GlobalSearch',
      pageCode: 'ERA.UC.GlobalSearch',
      noHeader: true,
    },
    component: () => import('~/pages/GlobalSearch.vue'),
  },
  {
    path: '/:lang/sentry-example-page',
    name: 'SentryExamplePage',
    meta: {
      name: 'SentryExamplePage',
      pageCode: 'ERA.UC.GlobalSearch',
      noHeader: true,
    },
    component: () => import('~/pages/sentry-example-page.vue'),
  },
  {
    path: `/:lang/404`,
    name: '404',
    component: () => import('~/pages/404.vue'),
    meta: {
      title: '404页面',
      pageCode: 'ERA.UC.404',
      headerStyle: 'normal',
      layout: 'empty',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('~/pages/404.vue'),
    meta: {
      title: '404页面',
      pageCode: 'ERA.UC.404',
      headerStyle: 'normal',
      layout: 'empty',
    },
  },
]
